import { createAction, props } from "@ngrx/store";
import { Plant } from "src/model/class/general classes/plant";
import { PlantsStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Action add plant
 */
export const plantAddAction = createAction(
  PlantsStoreAction.ADD_PLANT,
  props<{ newPlant: Plant }>()
);

/**
 * Action update plant
 */
export const plantUpdateAction = createAction(
  PlantsStoreAction.UPDATE_PLANT,
  props<{ updatePlant: Plant }>()
);

/**
 * Action remove plant
 */
export const plantRemoveAction = createAction(
  PlantsStoreAction.REMOVE_PLANT,
  props<{ idPlant: number }>()
);

export const plantChangeWanAllowConnectionAction = createAction(
  PlantsStoreAction.CHANGE_WAN_CONNECTION_FLAG,
  props<{ idPlant: number; allowWanConnection: boolean }>()
);

/**
 * Update plant list with default supervision list to open
 */
export const plantDefaultSupervisionToOpenAction = createAction(
  PlantsStoreAction.CHANGE_PLANT_DEFAULT_SUPERVISION_TO_OPEN,
  props<{ idPlant: number; idSupervision: number; idEnvironment: number }>()
);

//#region  Current Plant Actions
/**
 * Change current plant selection
 */
export const currentPlantChangeSelectionAction = createAction(
  PlantsStoreAction.SELECTED_PLANT_CHANGED,
  props<{ selectedPlant: Plant }>()
);

/**
 * Action to unset current plant
 */
export const currentPlantUnsetAction = createAction(
  PlantsStoreAction.SELECTED_PLANT_UNSET
);

/**
 * Change current plant connection address
 */
export const currentPlantChangeConnectionAddressAction = createAction(
  PlantsStoreAction.SELECTED_PLANT_CHANGE_CONNECTION_ADDREESS,
  props<{ newAddressConnection: string }>()
);

/**
 * Change current plant connection address
 */
export const currentPlantChangeWanConnectionAction = createAction(
  PlantsStoreAction.SELECTED_PLANT_CHANE_WAN_CONNECTION_FLAG,
  props<{ allowWanConnection: boolean }>()
);

/**
 * Set current plant defualt supervision to open
 */
export const currentPlantChangeDefaultSupervisionToOpenAction = createAction(
  PlantsStoreAction.SELECTED_PLANT_CHANGE_DEFAULT_SUPERVISION_TO_OPEN,
  props<{ idSupervision: number; idEnvironment: number }>()
);

/**
 * Action overwrite plant
 */
export const plantOverwriteAction = createAction(
  PlantsStoreAction.OVERWRITE_PLANT,
  props<{ updatePlants: Array<Plant> }>()
);
//#endregion
